<template>
    <div class="notes-delete">
        <slot>
            <button
                class="button button--blank notes-delete__button"
                type="button"
                @click="showModal = true"
            >
                {{ $t('notes.delete.trigger') }}
            </button>
        </slot>
        <ConfirmModal
            v-if="showModal"
            name="notes-delete"
            :title="$t('notes.delete.title')"
            :ok-label="$t('misc.delete')"
            @confirmed="deleteNote"
            @canceled="showModal = false"
        >
            <template #content>
                <div>
                    <Spinner v-if="loading" />
                    <div class="notes-delete__content">
                        <p>{{ $t('notes.delete.content') }}</p>
                        <NotesComment :text="note.comment" />
                        <p v-html="$t('notes.delete.warning')" />
                    </div>
                    <TransitionExpand v-if="error">
                        <ErrorList :error="error" />
                    </TransitionExpand>
                </div>
            </template>
        </ConfirmModal>
    </div>
</template>

<script>
import { ConfirmModal } from '@speechki-frontend/shared/ui/modals';
import NotesComment from '../NotesComment/NotesComment';
import TransitionExpand from '@speechki-frontend/shared/ui/TransitionExpand';
import { ErrorList } from '@speechki-frontend/shared/ui/forms';
import { noteDelete } from '../../api/notes';

export default {
    name: 'NotesDelete',
    components: {
        ConfirmModal,
        NotesComment,
        TransitionExpand,
        ErrorList,
    },
    props: {
        note: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showModal: false,
            loading: false,
            error: null,
        };
    },
    methods: {
        async deleteNote() {
            try {
                this.loading = true;
                this.error = null;
                await noteDelete(this.note.id);
                this.$store.dispatch('pushToast', {
                    type: 'success',
                    title: 'Success',
                    text: 'Note successfully deleted',
                });
                this.$emit('delete', this.note.id);
            } catch (e) {
                this.error = e;
                this.$store.dispatch('pushToast', {
                    type: 'error',
                    text: e,
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style src="./NotesDelete.scss" lang="scss"></style>
